import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import SvgIcon from '../library/SvgIcon/SvgIcon.js';

import sanityClient from '../../sanity-client.js';
import imageUrlBuilder from '@sanity/image-url';
import { isMobile } from 'react-device-detect';

import './style.scss';

const builder = imageUrlBuilder(sanityClient);

function urlFor(source) {
  if (isMobile) {
    return builder.image(source).width(640).format('webp');
  }
  return builder.image(source).format('webp');
}

// Masthead
function RenderMastheadImage(props) {
  const mastheadImages = props.mastheadImages;
  const nav = props.nav;
  // const palettePrimary = props.mastheadImages[0].asset.metadata.palette.dominant

  return (
    <Row as="header" className="homepage-slide">
      <Col className="masthead__container">
        <div
          className="masthead__images lqip"
          style={{
            backgroundImage: `url(${mastheadImages[0].asset.metadata.lqip})`
          }}
        >
          <img src={urlFor(mastheadImages[0].asset).url()} alt={mastheadImages[0].alt} />
        </div>
        <div className="masthead__content">
          <Row>
            <Col>
              <h1 className="frontpage__title">Mark Austin</h1>
            </Col>
          </Row>

          <Row className=" masthead-logo__container">
            <Col>
              <SvgIcon icon="logo_white" />
              <ul id="masthead__nav" className="roboto--light">
                {nav.map((item, index) => {
                  return (
                    <li key={index}>
                      <a href={item.slug.current} className="link--white font-roboto--500">
                        {item.slug.current}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>

          <Row className=" masthead__social-icons">
            <Col>
              <ul>
                {/* <li className="network__item">
                  <a href="https://www.instagram.com/mark.vb.austin/" target="_blank" rel="noopener noreferrer">
                    <SvgIcon icon="instagram_white" width="30px" height="30px" />
                  </a>
                </li>
                <li>
                  <a href="mailto:mark.vb.austin@gmail.com" target="_blank" rel="noopener noreferrer">
                    <SvgIcon icon="mail_white" width="30px" height="30px" />
                  </a>
                </li> */}
              </ul>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
}

// Slide
function RenderImage(props) {
  const title = props.title;
  const image = props.image;
  const link = props.link;

  return (
    <>
      <Row as="section" className=" homepage-slide">
        <Col
          className="background-image"
          style={{
            backgroundImage: `url(${urlFor(image).url()})`
          }}
        >
          <h2 className="homepage-slide__title">
            <a href={link} className="link--white">
              {title}
            </a>
          </h2>
        </Col>
      </Row>
    </>
  );
}

// Render content
function FullpageImage(props) {
  const masthead = props.masthead;
  const mastheadImages = props.mastheadImages;
  const nav = props.nav;

  const title = props.title;
  const image = props.image;
  const link = props.link;

  if (masthead) {
    return <RenderMastheadImage mastheadImages={mastheadImages} nav={nav} {...props} />;
  }
  return <RenderImage link={link} title={title} image={image} />;
}

export default FullpageImage;

FullpageImage.propTypes = {
  masthead: PropTypes.bool,
  title: PropTypes.string
};
